// Account recovery key.
//
// The vault refuses password-only storage (USERLAND-SEED-VAULT-AUTH-DESIGN
// gate 3): a user-held recovery slot must exist. That slot belongs to the
// ACCOUNT, not to any wallet — it is minted once, at registration, together
// with the keyring, so creating or importing a wallet never asks for anything.
//
// 24 chars x 32-symbol alphabet = 120 bits, unbiased; visually ambiguous
// symbols excluded.

const RECOVERY_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'

export function generateRecoveryKey(): string {
  const bytes = new Uint8Array(24)
  crypto.getRandomValues(bytes)
  let out = ''
  for (let i = 0; i < bytes.length; i++) {
    out += RECOVERY_ALPHABET[(bytes[i] ?? 0) % RECOVERY_ALPHABET.length]
    if (i % 4 === 3 && i < bytes.length - 1) out += '-'
  }
  return out
}
